import get from "lodash/get";
import React, { Component } from "react";
import { withAmp } from "../AMP/AmpContext";
import LazyVideoPlayer from "../LazyVideoPlayer";

class VideoInContext extends Component {
  render() {
    const { amp, video, options } = this.props;

    // Get Thumbnail
    const thumbnailImage =
      get(
        (video.thumbnailImage || []).find((tn) => tn.aspectRatio === "4x3"),
        "image.file.url"
      ) ||
      get(video, "thumbnailImage[0].image.file.url") ||
      get(video, "thumbnailImage[0]");

    // Configs
    const youtubeConfig = {
      playerVars: {
        controls: 1,
        rel: 0,
        color: "white",
        disablekb: 1,
        modestbranding: 1,
        ...options,
      },
    };

    // If Youtube
    if (video.youtubeId != null) {
      return amp === true ? (
        <amp-youtube
          width="480"
          height="270"
          layout="responsive"
          data-videoid={video.youtubeId}
          data-param-rel="0"
        ></amp-youtube>
      ) : (
        <LazyVideoPlayer
          url={`https://www.youtube.com/watch?v=${get(video, "youtubeId")}`}
          options={youtubeConfig.playerVars}
        />
      );
    }

    // If Static Video
    if (get(video, "video.file.url") != null) {
      return amp === true ? (
        <amp-video
          width="480"
          height="270"
          layout="responsive"
          src={get(video, "video.file.url")}
          poster={thumbnailImage}
        ></amp-video>
      ) : (
        <LazyVideoPlayer
          url={
            get(video, "video.file.url", "").includes("http")
              ? get(video, "video.file.url")
              : `https://www.youtube.com/watch?v=${get(video, "video.file.url")}`
          }
          options={youtubeConfig.playerVars}
          thumbnailUrl={thumbnailImage}
          posterUrl={thumbnailImage}
        />
      );
    }
    // No video provided
    return null;
  }
}

export default withAmp(VideoInContext);
